import Burger from "./Burger";
import { Link, useRouteMatch } from "react-router-dom";
import { RiAccountPinCircleLine } from "react-icons/ri";
import { BiGlobeAlt } from "react-icons/bi";

const Header = () => {
    let match = useRouteMatch();

    return (
        <header className="main-header">
            <nav className="main-nav">
                <ul className="main-nav-list">
                    <li>
                        <Burger />
                    </li>
                    <li>
                        <Link to={`${match.url}eco/home`} className="btn-type-1-ignore">
                            <BiGlobeAlt />
                            <span className="app-name">ECO</span>
                        </Link>
                    </li>
                    <li>
                        <Link to={`${match.url}eco/user-account`} className="btn-type-1">
                            <RiAccountPinCircleLine />
                            <span className="medium-type large-type">
                                Profile
                            </span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
